<section class="default-page">
  <h1>Hyperscene demo</h1>
  <nav class="default-page__links" aria-label="Demo sections">
    <a class="default-page__link" routerLink="/showcase">
      <strong>Showcases</strong>
      <span>Applied scenarios: maintenance, construction QA, 4D BIM and digital twins.</span>
    </a>
    <a class="default-page__link" routerLink="/viewer">
      <strong>Engine stand</strong>
      <span>The full viewer with every engine setting, tool and diagnostic.</span>
    </a>
  </nav>
</section>
